
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import * as AUDIOGUIDE from '@/store/audioguide/types'
import { SvgIcon, IconTextToSpeech } from '@/@next/components/icons'
import { CLoader } from '@/components/loader'
import { CButton } from '@/components/form-controls/button'
import { TextToSpeechMixin } from '@/@next/mixins'

const config = {
  name: 'l-default-text-to-speech-controls',
  components: {
    CLoader,
    CButton,
    SvgIcon,
    IconTextToSpeech
  }
}

@Component(config)
export default class LDefaultTextToSpeechControls extends Mixins(TextToSpeechMixin) {

  @Getter(AUDIOGUIDE.GET_STATUS) audioguideStatus!: boolean

  debouncing: boolean = false

  created () {
    this.resetTts()
  }

  get CSSClasses () {
    return {
      'is-Open': this.showTtsControls,
    }
  }

  getTextToSpeechElement () {
    if (this.debouncing) return
    this.debouncing = true
    const arr = document.querySelectorAll('[data-to-speech]')
    arr.forEach((el: Element) => {
      for (const childNode of el.childNodes) {
        this.addTtsItem({
          element: childNode,
          text: childNode.textContent,
          locale: this.$i18n.locale
        })
        childNode.addEventListener('click', () => this.clickOnTtsItem(childNode.textContent), false);
      } 
    })
    setTimeout(() => this.debouncing = false, 500)
  }

  @Watch('$route')
  onRouteChange () {
    this.resetTts();
    setTimeout(() => this.getTextToSpeechElement(), 500)
  }

  @Watch('audioguideStatus')
  onAudioGuideStatusChange () {
    console.log(' Audio Guide status changed to ' + this.audioguideStatus)
    if (this.audioguideStatus) this.stopTts()
  }

  playPause () {
    console.log(' Play pause')
    if (this.ttsIsPaused) this.playTts()
    else this.pauseTts()
  }

  mounted () {
    this.onRouteChange();
  }

}
